<template>
  <div id="printdatatable" class="table_wrapper white-back" style="width: 100vw">

      <div class="reportdetails white-back pb-2">
          <h3 class="body-2" v-if="$root.CurrentBusiness">{{$root.CurrentBusiness.BusinessName}}</h3>

          <p class="caption">
              <span class="font-medium">Report</span>: {{propsObj.reportTitle}}
          </p>

          <p class="caption" v-if="propsObj.itemLabel">
              <span class="font-medium">{{propsObj.itemLabel}}</span>: 
              <span class="item-link">{{propsObj.itemName}}</span>
          </p>

          <p class="caption" v-if="propsObj.periodLabel == 'Period'">
              <span class="font-medium">Period</span>: {{propsObj.startDate | moment("DD-MMM-YYYY")}} To {{propsObj.endDate | moment("DD-MMM-YYYY")}}
          </p>

          <p class="caption" v-else>
              <span class="font-medium">As On</span>: {{propsObj.endDate | moment("DD-MMM-YYYY")}}
          </p>

          <!-- <p class="caption" v-if="advancedFilterObj && Object.keys(advancedFilterObj).length">
            <span v-for="(filter, key, index) in advancedFilterObj">
              <span class="font-medium">{{filter.name}}</span>: {{filter.value}}{{index!=Object.keys(advancedFilterObj).length-1 ? ', ': ''}}
            </span>
          </p> -->

          <p class="caption" v-if="reportFilterObj && Object.keys(reportFilterObj).length">
            <span v-for="(filter, key, index) in reportFilterObj">
              <span class="font-medium">{{filter.name}}</span>: {{filter.value}}{{index!=Object.keys(reportFilterObj).length-1 ? ', ': ''}}
            </span>
          </p>

          <div class="invoice-footer" style="position:relative">
              <div class="branding grey-back" style="position:absolute;right:0;bottom:0">
                  <a href="https://bizopsapp.com/" target="_blank">
                      <div class="branding-box">
                          <div class="dark-opacity-color powered right-align">Powered By</div>
                          <div class="font16 title primary-color">
                              <img class="brand_logo" src="../../../assets/BizOpsApp_Icon_24x24.png" alt="bizops_logo">BizOps App
                          </div>
                      </div>
                  </a>
              </div>
          </div>
        
      </div>

      <template v-if="$route.params.reportid==205 || $route.params.reportid==310 || $route.params.reportid==311 || $route.params.reportid==312 || $route.params.reportid==418 || $route.params.reportid==419 || $route.params.reportid==420">
        <table id="my-table-print" class="report-container-table" style="width:100%;border-collapse: collapse;" v-if="propsObj.reportData">

            <thead class="report-header">
                <tr>
                    <td class="pt-1 pb-1 pl-2 pr-2 grey-back dark-opacity-color" :class="{'right-align': item.type=='number'}" v-for="(item, index) in propsObj.reportData.headerRow" :key="'header'+index">
                      <strong>{{item.headerName ? item.headerName : ''}}</strong>
                    </td>
                </tr>
            </thead>

            <tbody class="report-content" v-if="propsObj.reportData.detailRows">
              <template v-for="(item, index) in propsObj.reportData.detailRows">
                
                <div :key="item.transactionId || index">
                  <tr>
                      <td class="pa-1" v-for="(col, colIndex) in propsObj.columns" :key="'itemrowcol'+colIndex">
                          <span v-if="propsObj.reportData.headerRow[colIndex].type == 'date'">{{item.cols[col] | moment("DD-MMM-YYYY")}}</span>
                          <span :class="{'font-medium': ($route.params.reportid == 601 || $route.params.reportid == 602 || $route.params.reportid == 603 || $route.params.reportid == 901) && item.accountGroupId || item.mainRow}" v-else-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                          <span :class="{'font-medium': ($route.params.reportid == 601 || $route.params.reportid == 602 || $route.params.reportid == 603 || $route.params.reportid == 901) && item.accountGroupId || item.mainRow}" v-else>{{item.cols[col] ? item.cols[col] : ''}}</span>
                      </td>
                  </tr>

                  <tr v-if="item.subHeaders">
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"><strong>{{item.subHeaders.srNo}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"><strong>{{item.subHeaders.productName}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.hsnCode"><strong>{{item.subHeaders.hsnCode}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align"><strong>{{item.subHeaders.qty}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"><strong>{{item.subHeaders.unit}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align"><strong>{{item.subHeaders.rate}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.discount"><strong>{{item.subHeaders.discount}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align"><strong>{{item.subHeaders.taxableValue}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.gstPercentage"><strong>{{item.subHeaders.gstPercentage}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cgst"><strong>{{item.subHeaders.cgst}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.sgst"><strong>{{item.subHeaders.sgst}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.utgst"><strong>{{item.subHeaders.utgst}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.igst"><strong>{{item.subHeaders.igst}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cessPercentage"><strong>{{item.subHeaders.cessPercentage}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage"><strong>{{item.subHeaders.cessOnQtyPercentage}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cess"><strong>{{item.subHeaders.cess}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align"><strong>{{item.subHeaders.total}}</strong></td>
                  </tr>

                  <template v-for="(detailItem, detailItemIndex) in item.cols.itemDetailRows">
                      <tr :key="'detailrow' + (detailItemIndex + index)" v-if="item.subHeaders">
                          <td class="pt-1 pb-1 pl-2 pr-2"></td>
                          <td class="pt-1 pb-1 pl-2 pr-2">{{detailItem.srNo}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2">{{detailItem.productName}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.hsnCode">{{detailItem.hsnCode}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2 right-align">{{$root.numberToLocale(detailItem.qty)}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2">{{detailItem.unit}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2 right-align">{{$root.numberToLocale(detailItem.rate)}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.discount">{{$root.numberToLocale(detailItem.discount)}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2 right-align">{{$root.numberToLocale(detailItem.taxableValue)}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.gstPercentage">{{$root.numberToLocale(detailItem.gstPercentage)}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cgst">{{$root.numberToLocale(detailItem.cgst)}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.sgst">{{$root.numberToLocale(detailItem.sgst)}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.utgst">{{$root.numberToLocale(detailItem.utgst)}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.igst">{{$root.numberToLocale(detailItem.igst)}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cessPercentage">{{$root.numberToLocale(detailItem.cessPercentage)}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage">{{$root.numberToLocale(detailItem.cessOnQtyPercentage)}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cess">{{$root.numberToLocale(detailItem.cess)}}</td>
                          <td class="pt-1 pb-1 pl-2 pr-2 right-align">{{$root.numberToLocale(detailItem.total)}}</td>
                      </tr>
                  </template>

                  <tr v-if="item.subHeaders && item.cols.subTotal">
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"><strong>{{item.cols.subTotal.srNo}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"><strong>{{item.cols.subTotal.productName}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.hsnCode"><strong>{{item.cols.subTotal.hsnCode}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align"><strong>{{$root.numberToLocale(item.cols.subTotal.qty)}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"><strong>{{item.cols.subTotal.unit}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align"><strong>{{$root.numberToLocale(item.cols.subTotal.rate)}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.discount"><strong>{{$root.numberToLocale(item.cols.subTotal.discount)}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align"><strong>{{$root.numberToLocale(item.cols.subTotal.taxableValue)}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.gstPercentage"><strong>{{$root.numberToLocale(item.cols.subTotal.gstPercentage)}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cgst"><strong>{{$root.numberToLocale(item.cols.subTotal.cgst)}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.sgst"><strong>{{$root.numberToLocale(item.cols.subTotal.sgst)}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.utgst"><strong>{{$root.numberToLocale(item.cols.subTotal.utgst)}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.igst"><strong>{{$root.numberToLocale(item.cols.subTotal.igst)}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cessPercentage"><strong>{{$root.numberToLocale(item.cols.subTotal.cessPercentage)}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage"><strong>{{$root.numberToLocale(item.cols.subTotal.cessOnQtyPercentage)}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cess"><strong>{{$root.numberToLocale(item.cols.subTotal.cess)}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align"><strong>{{$root.numberToLocale(item.cols.subTotal.total)}}</strong></td>
                  </tr>

                  <tr v-if="item.subHeaders && item.cols.billAddOns">
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.hsnCode"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.discount"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"><strong>{{item.cols.billAddOns.srNo}}</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.gstPercentage"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.cgst"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.sgst"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.utgst"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.igst"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.cessPercentage"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.cess"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align"><strong>{{$root.numberToLocale(item.cols.billAddOns.total)}}</strong></td>
                  </tr>

                  <tr v-if="item.subHeaders && item.cols.tdsAddOns">
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.hsnCode"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.discount"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"><strong>Total Tds</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.gstPercentage"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.cgst"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.sgst"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.utgst"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.igst"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.cessPercentage"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.cess"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align"><strong>{{$root.numberToLocale(item.cols.tdsAddOns.total)}}</strong></td>
                  </tr>

                  <tr v-if="item.subHeaders && item.cols.total">
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2" v-if="item.subHeaders && item.subHeaders.hsnCode"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.discount"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2"><strong>Total</strong></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.gstPercentage"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cgst"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.sgst"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.utgst"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.igst"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cessPercentage"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align" v-if="item.subHeaders && item.subHeaders.cess"></td>
                      <td class="pt-1 pb-1 pl-2 pr-2 right-align"><strong>{{$root.numberToLocale(item.cols.total.total)}}</strong></td>
                  </tr>
                </div>

              </template>
                

                <tr style="border-top:1px #f0f0f0 solid;border-bottom:1px #f0f0f0 solid;background-color:#ffffff !important" v-if="propsObj.reportData.footerRow">
                    <td class="pa-1" v-for="(col, index) in propsObj.columns" :key="'footerrow'+index" :class="{'right-align':typeof(propsObj.reportData.footerRow[col])=='number'}">
                      <!-- <strong>{{propsObj.reportData.footerRow[col] ? $root.numberToLocale(propsObj.reportData.footerRow[col]) : '-'}}</strong> -->
                        <strong>
                            <span v-if="typeof(propsObj.reportData.footerRow[col])=='number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{propsObj.reportData.footerRow[col] ? $root.numberToLocale(propsObj.reportData.footerRow[col]) : ''}}</span>
                            <span v-else>{{propsObj.reportData.footerRow[col] ? propsObj.reportData.footerRow[col] : ''}}</span>

                        </strong>
                    </td>
                </tr>

                <tr style="border-top:1px #f0f0f0 solid;border-bottom:1px #f0f0f0 solid;background-color:#ffffff !important" v-for="(row, index) in propsObj.reportData.summaryRows" :key="'summaryrow'+index" v-if="propsObj.reportData.summaryRows">
                    <td class="pa-1" v-for="(col, index) in propsObj.columns" :key="'summaryrowcol'+index">
                      <strong>
                          <span v-if="typeof(row[col])=='number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{row[col] ? $root.numberToLocale(row[col]) : '-'}}</span>
                          
                          <span v-else-if="$route.params.reportid==109">
                            <template v-if="col == 'expiredIn'">
                              {{row[col] > 0 ? row[col] : '-'}}
                            </template>
                            <template v-else>
                              {{row[col] ? row[col] : '-'}}
                            </template>
                          </span>
                          
                          <span v-else>{{row[col] ? row[col] : '-'}}</span>
                      </strong>
                    </td>
                </tr>
                
            </tbody>
        </table>
      </template>

      <template v-else>
        <table id="my-table-print" class="report-container-table" style="width:100%;border-collapse: collapse;" v-if="propsObj.reportData">

            <thead class="report-header">
                <tr>
                    <!-- <td class="pa-1" v-for="(value, key) in propsObj.reportData.headerRow">
                      <strong>{{value ? value : '-'}}</strong>
                    </td> -->
                    <td class="pt-1 pb-1 pl-2 pr-2 grey-back dark-opacity-color" :class="{'right-align': item.type=='number'}" v-for="(item, index) in propsObj.reportData.headerRow" :key="'header'+index">
                      <strong>{{item.headerName ? item.headerName : ''}}</strong>
                      <!-- <template v-if="$route.params.reportid==201">
                      <strong> {{ item.headerName == 'To Receive' ? $root.fn_getDebitLabel() : item.headerName == 'To Pay' ? $root.fn_getCreditLabel() : item.headerName }}</strong>
                      </template>
                      <template v-else>
                        <strong>{{ item.headerName ? item.headerName : '' }}</strong>
                      </template> -->
                    </td>
                </tr>
            </thead>

          <!--  <tfoot class="report-footer" v-if="propsObj.reportData.footerRow">
                <tr>
                    <td class="pa-1" v-for="(col, index) in propsObj.columns" :key="index">
                      <strong>{{propsObj.reportData.footerRow[col] ? $root.numberToLocale(propsObj.reportData.footerRow[col]) : '-'}}</strong>
                    </td>
                </tr>
                <tr class="noborder">
                  <td class="noborder"><div class="page-footer-space"></div></td>
                </tr>
            </tfoot> -->

            <!-- In case of outstanding recivable/payable reports -->
            <!-- <tfoot class="report-footer" v-if="propsObj.reportData.summaryRows">
                <tr v-for="(row, index) in propsObj.reportData.summaryRows" :key="index">
                    <td class="pa-1" v-for="(col, index) in propsObj.columns" :key="index">
                      <strong>{{row[col] ? $root.numberToLocale(row[col]) : '-'}}</strong>
                    </td>
                </tr>
                <tr class="noborder">
                  <td class="noborder"><div class="page-footer-space"></div></td>
                </tr>
            </tfoot> -->
            <!-- end -->

            <tbody class="report-content" v-if="propsObj.reportData.detailRows">
                <tr v-for="(item, index) in propsObj.reportData.detailRows" :key="'itemrow'+index">
                    <td class="pa-1" v-for="(col, colIndex) in propsObj.columns" :key="'itemrowcol'+colIndex" :class="{'right-align': typeof(item.cols[col])=='number' && !fn_isSubItems(item, col, colIndex), 'pl-4':fn_leftPad(item, col, colIndex)}">
                        <!-- <span v-if="propsObj.reportData.headerRow[col] == 'Date'">{{item.cols[col] | moment("DD-MMM-YYYY")}}</span> -->
                        <span v-if="propsObj.reportData.headerRow[colIndex].type == 'date'">{{item.cols[col] | moment("DD-MMM-YYYY")}}</span>
                        <span :class="{'font-medium': ($route.params.reportid == 601 || $route.params.reportid == 602 || $route.params.reportid == 603 || $route.params.reportid == 901) && item.accountGroupId || item.mainRow}" v-else-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                        <span :class="{'font-medium': ($route.params.reportid == 601 || $route.params.reportid == 602 || $route.params.reportid == 603 || $route.params.reportid == 901) && item.accountGroupId || item.mainRow}" v-else>{{item.cols[col] ? item.cols[col] : ''}}</span>
                    </td>
                </tr>

                <tr style="border-top:1px #f0f0f0 solid;border-bottom:1px #f0f0f0 solid;background-color:#ffffff !important" v-if="propsObj.reportData.footerRow">
                    <td class="pa-1" v-for="(col, index) in propsObj.columns" :key="'footerrow'+index" :class="{'right-align':typeof(propsObj.reportData.footerRow[col])=='number'}">
                      <!-- <strong>{{propsObj.reportData.footerRow[col] ? $root.numberToLocale(propsObj.reportData.footerRow[col]) : '-'}}</strong> -->
                        <strong>
                            <span v-if="typeof(propsObj.reportData.footerRow[col])=='number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{propsObj.reportData.footerRow[col] ? $root.numberToLocale(propsObj.reportData.footerRow[col]) : ''}}</span>
                            <span v-else>{{propsObj.reportData.footerRow[col] ? propsObj.reportData.footerRow[col] : ''}}</span>
                            <!-- <span v-else>
                              <template v-if="$route.params.reportid==201">
                                {{ propsObj.reportData.footerRow[col] == 'To Receive' ? $root.fn_getDebitLabel() : propsObj.reportData.footerRow[col] == 'To Pay' ? $root.fn_getCreditLabel() : propsObj.reportData.footerRow[col] }}
                              </template>
                              <template v-else>
                                {{propsObj.reportData.footerRow[col] ? propsObj.reportData.footerRow[col] : ''}}
                              </template>
                            </span> -->
                        </strong>
                    </td>
                </tr>

                <tr style="border-top:1px #f0f0f0 solid;border-bottom:1px #f0f0f0 solid;background-color:#ffffff !important" v-for="(row, index) in propsObj.reportData.summaryRows" :key="'summaryrow'+index" v-if="propsObj.reportData.summaryRows">
                    <td class="pa-1" v-for="(col, index) in propsObj.columns" :key="'summaryrowcol'+index">
                      <strong>
                          <span v-if="typeof(row[col])=='number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{row[col] ? $root.numberToLocale(row[col]) : '-'}}</span>
                          
                          <span v-else-if="$route.params.reportid==109">
                            <template v-if="col == 'expiredIn'">
                              {{row[col] > 0 ? row[col] : '-'}}
                            </template>
                            <template v-else>
                              {{row[col] ? row[col] : '-'}}
                            </template>
                          </span>
                          
                          <span v-else>{{row[col] ? row[col] : '-'}}</span>
                      </strong>
                    </td>
                </tr>
                
                <!-- <tr class="noborder">
                  <td class="noborder"><div class="page-footer-space"></div></td>
                </tr> -->
            </tbody>
        </table>
      </template>

      <!-- <div class="page-footer">
          <div class="branding watermark">
              <div style="font-size:8px !important">Powered By</div>
              <div style="font-size:10px !important" class="title primary-color">
                  <img src="../../../assets/Final_BizOpsLogo.svg" class="brand_logo logo_small" alt="bizops_logo">
                  BizOps App
              </div>
          </div>
      </div> -->

      <!-- <div class="invoice-footer mt-4">
          <div class="branding grey-back">
            <a href="https://bizopsapp.com/" target="_blank">
                <div class="branding-box">
                    <div class="dark-opacity-color powered">Powered By</div>
                    <div class="font16 title primary-color">
                        <img class="brand_logo" src="../../../assets/BizOpsApp_Icon_24x24.png" alt="bizops_logo">BizOps App
                    </div>
                </div>
            </a>
          </div>
      </div> -->
  </div>
</template>

<script>
// const transactionForms = require('../../../config.js').configs.transactionForms;
export default{
  props:['propsObj', 'reportFilterObj'],
  methods:{
     fn_makeRowsColsStrong: function(item, col){
        if((this.$route.params.reportid == 601 || this.$route.params.reportid == 901) && item.accountGroupId){
            return true;
        }
        else if(this.$route.params.reportid == 602 || this.$route.params.reportid == 603){
            if(!item.linkedAccounts){
                return true;
            }
            else if(item.linkedAccounts && item.linkedAccounts.length == 1){
                if(this.$route.params.reportid == 602){
                    if((col == 'purchaseAccountName' || col == 'purchaseAmount') && !item.cols.purchaseAccountId){
                        return true;
                    }
                    else if((col == 'saleAccountName' || col == 'saleAmount') && !item.cols.saleAccountId){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
                else{
                    if((col == 'assetAccountName' || col == 'assetAmount') && !item.cols.assetAccountId){
                        return true;
                    }
                    else if((col == 'liabilityAccountName' || col == 'liabilityAmount') && !item.cols.liabilityAccountId){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
            }
            else{
                return false;
            }
        }
        else{
            return false;
        }
    },

    fn_leftPad: function(item, col, colIndex){
        if(!this.fn_makeRowsColsStrong(item, col) && this.$route.params.reportid == 603 && (colIndex == 0 || colIndex == 2)){
        return true;
        }        
        else{
        return false;
        }
    },

    fn_isSubItems: function(item, col, colIndex){
        if(!this.fn_makeRowsColsStrong(item, col) && this.$route.params.reportid == 603 && (colIndex == 1 || colIndex == 3)){
        return true;
        }        
        else{
        return false;
        }
    },
    // fn_getTransactionType: function(listId){
    //   for(let i=0; i<transactionForms.length; i++){
    //     if(transactionForms[i].id==listId){
    //       return transactionForms[i].title;
    //     }
    //   }
    // }
  }
}
</script>

<style scoped>
  .report-container-table tbody tr td{
      max-width: 200px;
      white-space: normal;
  } 
  #my-table-print tbody tr:nth-child(even) {background-color: #f9f9f9};
  /* #my-table-print tbody tr:last-child{background-color:#ffffff}; */
</style>


// WEBPACK FOOTER //
// src/components/newreports/print_report_templates/general.vue